/* eslint-disable @typescript-eslint/no-explicit-any */
import { use } from "react";
import { __ } from "@/lib/i18n/functions";
import { resolveCategoriesTree } from "@/lib/prismic/categories";
import { appLocales } from "@/lib/i18n";
import { segments } from "@/locales/segment";
import Image from "next/image";
import Link from "next/link";

const Catalogue = ({ resolution }: TemplateProps) => {
  const homeHref = resolution.locale === appLocales.defaultLocale ? "/" : `/${resolution.locale}/`;

  const categoriesTree = use(resolveCategoriesTree(resolution.locale));

  let defaultCategoriesTree = categoriesTree;
  if (resolution.locale !== "fr") {
    defaultCategoriesTree = use(resolveCategoriesTree("fr"));
  }

  return (
    <div className="container flex w-full flex-row gap-5 px-4 py-10 xl:px-7.5">
      <div className="w-full">
        <h1 className="h2 mb-3">{__("Catalogue", resolution.locale)}</h1>
        {categoriesTree.length > 0 ? (
          <>
            <span className="mt-3 block text-sm text-[#9C9C9C]">
              {categoriesTree.length} {__("categories", resolution.locale)}
            </span>
            <ul className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              {categoriesTree.map((child: any) => {
                const defaultChild =
                  resolution.locale === "fr"
                    ? child
                    : defaultCategoriesTree.find((c: any) => {
                        return c.alternate_languages.find((al: any) => al.id === child.id);
                      });

                return (
                  <li key={child.id} className="group relative flex flex-col-reverse gap-[0.625rem]">
                    <h3 className="font-geist text-center text-lg uppercase">{child.data.title}</h3>
                    <figure className="aspect-[25/16] w-full overflow-hidden rounded-md bg-[#F9F7F5]">
                      {defaultChild?.data?.featuredImage?.url && (
                        <Image
                          src={defaultChild.data.featuredImage.url}
                          alt={defaultChild.data.featuredImage.alt || child.data.title}
                          width={defaultChild.data.featuredImage.dimensions.width}
                          height={defaultChild.data.featuredImage.dimensions.height}
                          className="h-full w-full object-cover transition group-hover:scale-105"
                        />
                      )}
                    </figure>
                    <Link
                      href={`${homeHref}${segments[(resolution.locale as keyof typeof segments) || "fr"].categories}/${child.uid}`}
                      className="absolute inset-0 z-10"
                    />
                  </li>
                );
              })}
            </ul>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Catalogue;

Catalogue.generateMetadata = async (resolution: any) => {
  const catalogueSegment = segments[resolution.locale as keyof typeof segments]?.catalogue;
  const canonical =
    resolution.locale === appLocales.defaultLocale ? `/${catalogueSegment}` : `/${resolution.locale}/${catalogueSegment}`;

  return {
    title: __("Catalogue", resolution.locale),
    alternates: {
      canonical,
    },
  };
};
